import React from 'react';
import Reveal from '../lib/Reveal.jsx';

// Curated public repos from github.com/jb-612 — see
// .workitems/N01-foundation/F04-landing-zone-page/references/repo-audit.md
// for the full recommendation (visible / gated / omitted).
const REPOS = [
  { name: 'research-agent',            desc: 'Applied research agent for emerging-tech evaluation.',           url: 'https://github.com/jb-612/research-agent' },
  { name: 'knowledge-agent',           desc: 'Graph-based context, retrieval, and reasoning utilities.',       url: 'https://github.com/jb-612/knowledge-agent' },
  { name: 'cursor-analytics-platform', desc: 'Developer KPI dashboard and simulator built in Go.',             url: 'https://github.com/jb-612/cursor-analytics-platform' },
  { name: 'enterprise-arch',           desc: 'Enterprise architecture artefacts and decision records.',        url: 'https://github.com/jb-612/enterprise-arch' },
  { name: 'mortgage_concierge',        desc: 'Fintech vertical demo — assisted mortgage workflows.',           url: 'https://github.com/jb-612/mortgage_concierge' },
];

// Sixth cell: gated access CTA tied to the LandingZone form.
const GATED_CARD = {
  name: 'Request private access',
  desc: 'Top private repos available on request: agent-context-manager · eval-harness · fintech-skill-packs · core-banking-ai · knowledge-graph-engine. Short form, reviewed manually.',
  url: '/landing-zone?asset=code',
  gated: true,
};

const CELLS = [...REPOS, GATED_CARD];

export default function OpenSource({ tweaks }) {
  return (
    <section id="open-source" className="section" style={{ background: 'var(--paper-deep)' }}>
      <div className="container">
        <div className="grid12" style={{ marginBottom: 64, alignItems: 'end' }}>
          <Reveal style={{ gridColumn: 'span 6' }}>
            <div className="section-marker" style={{ marginBottom: 24 }}>
              {tweaks.sectionDividers === 'numbered' ? '04 / Open source' : 'Open source'}
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: 'clamp(36px, 5vw, 60px)', lineHeight: 1.05, letterSpacing: '-0.025em', margin: 0, textWrap: 'balance' }}>
              <span style={{ fontStyle: 'italic', color: 'var(--clay)' }}>Build,</span> test against real delivery, publish.
            </h2>
          </Reveal>
          <Reveal style={{ gridColumn: '8 / span 5' }}>
            <p style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--ink-60)', margin: 0, maxWidth: '40ch' }}>
              Public work spans applied research, knowledge systems, developer productivity, and fintech demonstrators. Private skill-packages and code samples are available on request.
            </p>
            <a href="https://github.com/jb-612" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ marginTop: 24 }}>
              View on GitHub <span style={{ fontFamily: 'var(--font-mono)' }}>↗</span>
            </a>
          </Reveal>
        </div>

        <Reveal stagger className="mobile-collapse-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0, borderTop: '1px solid var(--ink-24)' }}>
          {CELLS.map((r, i) => {
            const external = !r.gated;
            return (
              <a
                key={r.name}
                href={r.url}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                style={{
                  padding: '28px 24px',
                  borderRight: (i % 3 !== 2) ? '1px solid var(--ink-12)' : 'none',
                  borderBottom: i < 3 ? '1px solid var(--ink-12)' : 'none',
                  display: 'flex', flexDirection: 'column', gap: 12,
                  minHeight: 180, color: 'var(--ink)',
                  transition: 'background 200ms var(--ease)',
                  background: r.gated ? 'var(--clay-wash)' : 'transparent',
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = r.gated ? 'var(--clay-wash)' : 'var(--ink-06)'}
                onMouseLeave={(e) => e.currentTarget.style.background = r.gated ? 'var(--clay-wash)' : 'transparent'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span className="metric" style={{ fontSize: 14, color: 'var(--clay)' }}>
                    {r.gated ? '— gated' : 'jb-612 /'}
                  </span>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: 14, color: 'var(--ink-40)' }}>
                    {r.gated ? '→' : '↗'}
                  </span>
                </div>
                <div className="metric" style={{ fontSize: 17, color: 'var(--ink)', fontStyle: r.gated ? 'italic' : 'normal' }}>{r.name}</div>
                <p style={{ fontSize: 14, color: 'var(--ink-60)', margin: 0, lineHeight: 1.5 }}>{r.desc}</p>
              </a>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
}
